<template>
  <div class="nav d-flex align-center justify-center">
    <div class="d-flex align-center">
      <div class="nav-left d-flex align-center">
        <el-image class="image" :src="require('@/assets/images/logo.png')"></el-image>
        <div class="name d-flex f-column">
          <h3>区块链猪肉溯源</h3>
          <span>Blockchain pork traceability</span>
        </div>
      </div>
      <div class="nav-right d-flex">
        <div class="tab-box d-flex align-center">
          <router-link to="/home" tag="span">首页</router-link>
          <router-link to="/search" tag="span">溯源查询</router-link>
          <router-link to="/prod-introduce" tag="span">产品介绍</router-link>
          <router-link to="/news" tag="span">溯源新闻</router-link>
          <router-link to="/about" tag="span">关于我们</router-link>
          <router-link to="/blockchain-service" tag="span">区块链服务</router-link>
        </div>
        <div class="btn-box d-flex">
          <el-button type="primary" size="small" plain @click="handleNavigate('login')" v-if="!myinfo.userInfo"
            >登录</el-button
          >
          <el-button type="primary" size="small" plain @click="handleNavigate('register')" v-if="!myinfo.userInfo"
            >注册</el-button
          >
          <p style="font-size: 0.2rem;font-weight: 500;padding: 0.0875rem 0.1875rem;" v-if="myinfo.userInfo">欢迎您：{{myinfo.userInfo.realname}}</p>
          <el-button type="primary" size="small" plain @click="loginout('register')" v-if="myinfo.userInfo"
            >退出登录</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Nav',
  data() {
    return {
      myinfo: JSON.parse(localStorage.getItem("logininfo")) || ''
    }
  },
  methods: {
    handleNavigate(str) {
      this.$router.push({ name: 'Login', params: { type: str } })
    },
    loginout(){
      localStorage.clear();
      this.myinfo=''
    },
  }
}
</script>

<style lang="scss" scoped>
.nav {
  height: 1.125rem;
  border-bottom: 0.0125rem solid #ebebeb;
  &-left {
    margin-right: 2.7rem;
    .image {
      width: 0.6375rem;
      height: 0.6375rem;
    }
    .name {
      margin-left: 0.125rem;
      h3 {
        margin-bottom: 0.0625rem;
        font-size: 0.3rem;
      }
      span {
        font-size: 0.1625rem;
        color: #666;
      }
    }
  }
  &-right {
    .tab-box {
      span {
        padding: 0 0.25rem;
        font-size: 0.2rem;
        cursor: pointer;
      }
      .router-link-active {
        color: #2373f0;
      }
    }
    .btn-box {
      .el-button {
        padding: 0.0875rem 0.1875rem;
        background-color: #fff;
        border-color: #2373f0;
        font-size: 0.175rem;
        color: #2373f0;
        &:nth-of-type(1) {
          margin: 0 0.25rem;
        }
        &:nth-of-type(2) {
          margin: 0;
        }
      }
    }
  }
}
</style>
